import ApiService from './ApiService';
import Constant from '../util/Constant';
import { getUniqueReferenceId } from '../util/Generator';

class AuthenticationService {
   static login(credentials) {
      let encoded = window.btoa(`${credentials.username}:${credentials.password}`);
      let url = `${Constant.URL}/AgentAuthentication`;
      let headers = {
         'Content-Type': 'text/xml',
         'Authorization': `Basic ${encoded}`,
      };
      return ApiService.postData(url, headers, this.createLoginRequest(credentials));
   }

   static createLoginRequest(credentials) {
      return `<?xml version="1.0" encoding="UTF-8"?>
               <vendorauthenticationrequest>
               <partenerid>${credentials.partnerId}</partenerid>
               <referenceid>${getUniqueReferenceId(credentials.partnerId)}</referenceid>
               <username>${credentials.username}</username>
               <password>${credentials.password}</password>
               </vendorauthenticationrequest>`;
   }

   static logout() {}
}

export default AuthenticationService;
